var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("g", { attrs: { id: "Group 12" } }, [
        _c("g", { attrs: { id: "marketing 1", "clip-path": "url(#clip0)" } }, [
          _c("g", { attrs: { id: "Group" } }, [
            _c("path", {
              attrs: {
                id: "Vector",
                d: "M14.374 0C11.294 0 8.78827 2.54481 8.78827 5.62484C8.78827 8.70486 11.294 11.2106 14.374 11.2106C17.4541 11.2106 19.9989 8.70486 19.9989 5.62484C19.9989 2.54481 17.4541 0 14.374 0ZM14.9607 8.16441V8.28687C14.9607 8.61045 14.6984 8.87279 14.3748 8.87279C14.0512 8.87279 13.7889 8.61045 13.7889 8.28687V8.23066C13.5189 8.18331 13.2723 8.0823 12.9607 7.87844C12.6899 7.7013 12.614 7.33814 12.7912 7.06737C12.9683 6.79656 13.3315 6.72066 13.6022 6.89781C13.8878 7.08467 13.9804 7.09924 14.3708 7.09651C14.7478 7.09401 14.898 6.79812 14.9273 6.62371C14.9536 6.46711 14.9241 6.25892 14.6337 6.1563C14.1472 5.98432 13.6484 5.78698 13.295 5.5098C12.4903 4.87865 12.7332 3.43713 13.7889 3.0535V2.96866C13.7889 2.64508 14.0513 2.38274 14.3749 2.38274C14.6984 2.38274 14.9608 2.64508 14.9608 2.96866V3.00116C15.2495 3.08264 15.482 3.22998 15.6417 3.39244C15.8686 3.62317 15.8655 3.99414 15.6348 4.22101C15.4042 4.4478 15.0335 4.44479 14.8066 4.21449C14.7739 4.18257 14.5934 4.03207 14.2026 4.14976C14.0466 4.19675 14.0047 4.35854 13.9956 4.40698C13.9765 4.50815 14.0037 4.57635 14.0182 4.58776C14.2392 4.76111 14.6508 4.91943 15.0243 5.05149C16.5685 5.5973 16.3804 7.65118 14.9607 8.16441Z",
                fill: "white",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                id: "Vector_2",
                d: "M6.60936 18.0074L7.49945 17.0783L2.92095 12.4998L0.94792 14.4337C-0.314387 15.696 -0.314387 17.789 0.94792 19.0513C2.21202 20.3154 4.29946 20.3173 5.56548 19.0513L5.78075 18.836L6.77267 19.8279C7.00146 20.0567 7.37246 20.0568 7.60128 19.8279C7.8301 19.5991 7.8301 19.2282 7.60128 18.9993L6.60936 18.0074Z",
                fill: "white",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                id: "Vector_3",
                d: "M12.6012 14.273L5.72642 7.39815C5.41896 7.0907 4.89394 7.21413 4.75625 7.62717L3.49359 11.4151L8.58422 16.5058L12.3722 15.2431C12.7846 15.1056 12.9091 14.5808 12.6012 14.273Z",
                fill: "white",
              },
            }),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0" } }, [
          _c("rect", { attrs: { width: "20", height: "20", fill: "white" } }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }